import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1ihdo3a4lt: FaireBrandEntity = {
  token: "b_1ihdo3a4lt",
  type: "brand",
  name: "Lalavon",
  avatarUrl:
    "https://cdn.faire.com/fastly/e1260d00660718641db50f0663da965c501642f16dffd406ad7814e69516b06b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a763bec5df4437ccc4646996015895192368b95cde902e22fd12e2ed7b7d753a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e1260d00660718641db50f0663da965c501642f16dffd406ad7814e69516b06b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a763bec5df4437ccc4646996015895192368b95cde902e22fd12e2ed7b7d753a.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 174,
  isInsider: true,
  description:
    "Lalavon is a contemporary womens wholesale brand redefining modern luxury. Rooted in elevated design and quality craftsmanship, Lalavon offers a curated collection of fashion-forward pieces that balance timeless elegance with runway-inspired trends.\n\nFrom structured tailoring to fluid silhouettes, each garment is thoughtfully designed for the confident, style-conscious woman. Using premium fabrics, sophisticated color palettes, and refined detailing, Lalavon blends luxury with wearability ideal for boutiques and retailers who cater to a discerning clientele.\n\nWith a strong presence in key fashion marketplaces and trade shows, Lalavon has quickly become a go-to for trendsetting retailers seeking exclusivity, quality, and design innovation in their assortments.\n\nIn observance of the holiday season we will be closed from Dec.25th to Jan.2nd, we will resume our regular schedule on January 5th. All orders received on the 25th and after will be process by Jan. 5th. Thank you. ",
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:18:14.559Z",
    importedBy: "entity-db-cli",
  },
};
